export const Roles = {
  Admin: 'Administrateur',
  GestEsch: 'gest_esch',
  GestEtte: 'gest_ette',
  Sfp: "gest_sfp",
  Dipl: "gest_dipl",
  Gest_: "gest_",
  User: 'Utilisateur',
  ProgramManager: 'Gestionnaire',
  //Missing roles?
};
